import {
    handleEnabledIconMouseEnter as handleEnabledMouseEnter,
    handleEnabledIconMouseLeave as handleEnabledMouseLeave
} from 'lib/uiUtils';
import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    FormControl,
    InputAdornment,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    FiberPinRounded,
    VisibilityOffOutlined,
    VisibilityOutlined
} from '@material-ui/icons';
import theme from 'theme';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { validateComboFields } from 'lib/configUtils';
import { ComboPadrao, FormActions, FormStatusSwitch } from 'views/Components';
import { generateRandomPwd, getCodUsuarioRegistrou, isMissingValue } from 'lib/functions';

class UsuarioPartnerForm extends Component {
    state = {
        usuariopartner: {
            id: '',
            nomeusuario: '',
            email: '',
            senha: '',
            codfornecedor: '',
            inativousuario: ANAO
        },
        confirmPwd: '',
        errors: {},
        openAlert: false,
        messageAlert: '',
        fornecedores: [],
        isNewRecord: false,
        isView: false,
        showPwd: false,
        showConfirmPwd: false,
        schema: {
            nomeusuario: {
                presence: {
                    allowEmpty: false,
                    message: 'Nome do usuário obrigatório!'
                },
                length: { maximum: 50 },
                type: 'string'
            },
            email: {
                presence: {
                    allowEmpty: false,
                    message: 'E-mail inválido!'
                },
                length: { maximum: 200 },
                type: 'string'
            },
            senha: {
                presence: {
                    allowEmpty: false,
                    message: 'Senha obrigatória!'
                },
                length: { maximum: 30 },
                type: 'string'
            },
            codfornecedor: {
                presence: {
                    allowEmpty: false,
                    message: 'Fornecedor obrigatório!'
                },
                length: { maximum: 100 },
                type: 'integer'
            }
        }
    };

    _isMounted = false;
    safeSetState = safeSetState;

    /* Eventos dos ícones condicionados ao modo de visualização */
    // ao passar o cursor
    handleIconMouseEnter = (event) => {
        const { isView } = this.state;

        handleEnabledMouseEnter(event, isView);
    };

    // ao remover o cursor
    handleIconMouseLeave = (event) => {
        const { isView } = this.state;

        handleEnabledMouseLeave(event, isView);
    };

    /* Alterna a visibilidade da senha */
    handleToggleShowPassword = () => {
        const { isView } = this.state;

        if (!isView) {
            this.setState(prevState => ({
                showPwd: !prevState.showPwd
            }));
        }
    };

    /* Alterna a visibilidade da confirmação de senha */
    handleToggleShowConfirmPassword = () => {
        const { isView } = this.state;

        if (!isView) {
            this.setState(prevState => ({
                showConfirmPwd: !prevState.showConfirmPwd
            }));
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            await this.loadFornecedores();

            if (isNewRecord) {
                this.safeSetState({
                    isNewRecord: true,
                    isView: false,
                    usuariopartner: this.getUsuarioPartnerDefault()
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadUsuarioPartner(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar usuário partner:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar usuário partner!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna o usuário partner padrão */
    getUsuarioPartnerDefault = () => ({
        id: '',
        nomeusuario: '',
        email: '',
        senha: '',
        codfornecedor: '',
        inativousuario: ANAO
    });

    /* Carrega os fornecedores */
    loadFornecedores = async () => {
        const params = '?page=1&limit=1000&transportadora=S';
        const response = await api.get(`/fornecedor/active/true${params}`);

        this.safeSetState({ fornecedores: getResponseData(response) });
    };

    /* Carrega o usuário partner */
    loadUsuarioPartner = async (id, isView) => {
        const response = await api.get(`/usuariopartner/${id}`);
        const dados = getRecordFromResponse(response) || {};

        this.safeSetState({
            usuariopartner: {
                ...dados,
                inativousuario: dados.inativousuario || ANAO
            },
            confirmPwd: dados.senha || '',
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { usuariopartner } = this.state;
        const { name, value, checked } = event.target;

        let newValue = value;

        if (name === 'nomeusuario') {
            newValue = value.toUpperCase();
        }

        if (name === 'senha' || name === 'confirmPwd') {
            newValue = value.toUpperCase();
        }

        if (name === 'inativousuario') {
            newValue = checked ? ANAO : ASIM;
        }

        if (name === 'confirmPwd') {
            this.setState({ confirmPwd: newValue });

            return;
        }

        this.setState({
            usuariopartner: {
                ...usuariopartner,
                [name]: newValue
            }
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de usuário partner */
    getPayloadUsuarioPartner = () => {
        const { usuariopartner } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();

        if (isMissingValue(codusuarioregistrou)) {
            throw new Error('Código do usuário não encontrado!');
        }

        return {
            codfornecedor: usuariopartner.codfornecedor || '',
            nomeusuario: usuariopartner.nomeusuario || '',
            email: usuariopartner.email || '',
            senha: usuariopartner.senha || '',
            inativousuario: usuariopartner.inativousuario || ANAO,
            codusuarioregistrou
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { confirmPwd, isNewRecord, usuariopartner } = this.state;
        const { history, loadUsuarioPartner } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        if ((usuariopartner.senha || '') !== (confirmPwd || '')) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    confirmPwd: 'As senhas não coincidem!'
                }
            }));

            this.handleOpenAlert('As senhas não coincidem!');

            return;
        }

        const comboErrors = validateComboFields(
            usuariopartner,
            [
                {
                    field: 'codfornecedor',
                    message: 'Selecione um fornecedor válido!'
                }
            ]
        );

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione um fornecedor válido!');

            return;
        }

        try {
            const payload = this.getPayloadUsuarioPartner();

            if (isNewRecord) {
                await api.post('/usuariopartner', payload);
            } else {
                await api.put(`/usuariopartner/${usuariopartner.id}`, payload);
            }

            if (loadUsuarioPartner) loadUsuarioPartner();

            history.push('/admpartner/usuariopartner');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            const mensagemErro = error.response?.data?.error || '';

            if (mensagemErro.toLowerCase().includes('e-mail')) {
                this.setState(prevState => ({
                    errors: {
                        ...prevState.errors,
                        email: 'E-mail já em uso por outro usuário'
                    }
                }));

                this.handleOpenAlert('Verifique o e-mail inserido!');

                return;
            }

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/admpartner/usuariopartner');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schema, usuariopartner } = this.state;

        return validateSchemaFields(
            usuariopartner,
            schema,
            [
                'nomeusuario',
                'email',
                'senha',
                'codfornecedor'
            ]
        );
    };

    /* Gera a senha */
    onClickGeneratePassword = () => {
        const { isView } = this.state;

        if (!isView) {
            this.handleGeneratePwd();
        }
    };

    /* Gera uma senha aleatória */
    handleGeneratePwd = () => {
        const pwd = generateRandomPwd(8);

        this.setState(prev => ({
            usuariopartner: {
                ...prev.usuariopartner,
                senha: pwd
            },
            confirmPwd: pwd
        }));
    };

    render() {
        const {
            confirmPwd,
            errors,
            fornecedores,
            isNewRecord,
            isView,
            messageAlert,
            openAlert,
            showConfirmPwd,
            showPwd,
            usuariopartner
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Usuário Partner {usuariopartner.id}
                        </Typography>

                        <FormStatusSwitch
                            checked={usuariopartner.inativousuario !== ASIM}
                            name="inativousuario"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Nome do usuário"
                            name="nomeusuario"
                            value={usuariopartner.nomeusuario || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.nomeusuario || ''}
                            error={!!errors.nomeusuario}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            fullWidth
                        />
                    </Box>

                    <br />

                    <Box>
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            fullWidth
                            style={{
                                flex: '0 1 400px',
                                minWidth: 300
                            }}
                        >
                            <ComboPadrao
                                name={'codfornecedor'}
                                label={'Fornecedor'}
                                value={usuariopartner.codfornecedor}
                                onChange={this.onChange}
                                fieldId={'codfornecedor'}
                                listItems={fornecedores}
                                fieldDescription={'fantasia'}
                                helperText={errors.codfornecedor || ''}
                                error={!!errors.codfornecedor}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="E-mail"
                            name="email"
                            value={usuariopartner.email || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type="email"
                            autoComplete="email"
                            inputMode="email"
                            helperText={errors.email || ''}
                            error={!!errors.email}
                            disabled={isView}
                            inputProps={{ maxLength: 200 }}
                            fullWidth
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        alignItems="center"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="Senha"
                            name="senha"
                            value={usuariopartner.senha || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type={showPwd ? 'text' : 'password'}
                            autoComplete={isNewRecord ? 'new-password' : 'current-password'}
                            helperText={errors.senha || ''}
                            error={!!errors.senha}
                            disabled={isView}
                            inputProps={{ maxLength: 30 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title="Ver/ocultar senha">
                                            <span>
                                                {showPwd ? (
                                                    <VisibilityOffOutlined
                                                        onClick={this.handleToggleShowPassword}
                                                        onMouseEnter={this.handleIconMouseEnter}
                                                        onMouseLeave={this.handleIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                ) : (
                                                    <VisibilityOutlined
                                                        onClick={this.handleToggleShowPassword}
                                                        onMouseEnter={this.handleIconMouseEnter}
                                                        onMouseLeave={this.handleIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                )}
                                            </span>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                            style={{
                                flex: 1,
                                minWidth: 160
                            }}
                        />

                        <TextField
                            label="Confirmar senha"
                            name="confirmPwd"
                            value={confirmPwd || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type={showConfirmPwd ? 'text' : 'password'}
                            autoComplete={isNewRecord ? 'new-password' : 'current-password'}
                            helperText={errors.confirmPwd || ''}
                            error={!!errors.confirmPwd}
                            disabled={isView}
                            inputProps={{ maxLength: 30 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title="Ver/ocultar senha">
                                            <span>
                                                {showConfirmPwd ? (
                                                    <VisibilityOffOutlined
                                                        onClick={this.handleToggleShowConfirmPassword}
                                                        onMouseEnter={this.handleIconMouseEnter}
                                                        onMouseLeave={this.handleIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                ) : (
                                                    <VisibilityOutlined
                                                        onClick={this.handleToggleShowConfirmPassword}
                                                        onMouseEnter={this.handleIconMouseEnter}
                                                        onMouseLeave={this.handleIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                )}
                                            </span>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                            style={{
                                flex: 1,
                                minWidth: 160
                            }}
                        />

                        <Tooltip title="Gerar senha">
                            <FiberPinRounded
                                onClick={this.onClickGeneratePassword}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={{
                                    fontSize: 32,
                                    color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                    cursor: isView ? 'default' : 'pointer'
                                }}
                            />
                        </Tooltip>
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

UsuarioPartnerForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadUsuarioPartner: PropTypes.func
};

export default UsuarioPartnerForm;